<form [formGroup]="crsSearchForm">
    <cw-autocomplete [dataList]="dataList" [filterType]="3" formControlName="selectedItem" [placeholder]="placeholder"
        [loading]="loading" [totalResults]="totalResults" [selectedOptionInfo]="selectedItemInfo" [floating]="floating"
        (searchTextChange)="onSearchText($event)" (currentPageChange)="onUpdateResults($event)">
    </cw-autocomplete>
</form>